import { inject, Injectable } from '@angular/core';
import { ApiHttpService } from '../../api-http.service';
import {
  CustomHttpResponse, DocumentSections, SupplierCreditNoteItem,
  SupplierCreditNoteItemMapping,
} from '../../../models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SupplierCreditNoteItemMappingsService {
  apiService: ApiHttpService<SupplierCreditNoteItemMapping> = inject(ApiHttpService<SupplierCreditNoteItemMapping>);

  create(supplierCreditNoteItemMapping: SupplierCreditNoteItemMapping): Observable<SupplierCreditNoteItemMapping> {
    return this.apiService
      .post('/supplier_credit_note_item_mappings', supplierCreditNoteItemMapping)
      .pipe(map((result: CustomHttpResponse<SupplierCreditNoteItemMapping>) => result.body as SupplierCreditNoteItemMapping));
  }

  createWithClient(supplierCreditNoteItemMapping: SupplierCreditNoteItemMapping) {
    return this.apiService
      .post('/supplier_credit_note_item_mappings/create_with_client', supplierCreditNoteItemMapping)
      .pipe(map((result: CustomHttpResponse<SupplierCreditNoteItemMapping>) => result.body as SupplierCreditNoteItemMapping));
  }

  getForSupplierCreditNote(iri: string): Observable<DocumentSections<SupplierCreditNoteItemMapping>> {
      return this.apiService
        .getMany(`${iri}/supplier_credit_note_item_mappings`)
        .pipe(map((res) =>
          ({ [iri]: res.body['hydra:member'] as SupplierCreditNoteItemMapping[] })
        ));
    }

  getForSupplierCreditNoteItem(iri: string): Observable<SupplierCreditNoteItemMapping[]> {
    return this.apiService
      .getMany(`${iri}/supplier_credit_note_item_mappings`)
      .pipe(map((result) => result.body['hydra:member']));
  }

  patch(iri: string, update: SupplierCreditNoteItemMapping) {
    return this.apiService
      .patch(iri, update)
      .pipe(map((result: CustomHttpResponse<SupplierCreditNoteItemMapping>) => result.body as SupplierCreditNoteItemMapping));
  }

  delete(supplierCreditNoteItemMappingIri: string) {
    return this.apiService.delete(`${supplierCreditNoteItemMappingIri}`).pipe(map((result) => result));
  }
}
